/** Strip internal vendor names from user-facing API / notification text. */
export const sanitizeVendorMessage = (message: string): string => (
  message
    .replace(/\bAITUNNEL\b/gi, 'AI')
    .replace(/\baitunnel\b/gi, 'AI')
    .replace(/\s{2,}/g, ' ')
    .trim()
);
